/**
 * @file: 客户信息完善(原跟进)
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/8      1.0     Second version 查看 dop-webapp/src/pages/Customer/Follow/Follow.bak.js 逻辑
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent} from "react";
import { Link, Prompt } from "react-router-dom";
import {Alert,Spin,message,Button,Result,Modal,Popconfirm, Input} from 'antd';
import FormFormat from '@/components/FormFormat/FormFormat';
import dayjs from 'dayjs';
import qs from "query-string";
import FollowAction from "./Follow.action";
import {unlock} from "../../../api/common/lock";
import Lang from "@/components/Lang/Lang";
import {isEmpty,isEmptyObject } from '@utils/utils';
import {TargetLabel,NewBuyerLabel} from "@components/StatuLabel/statuBuyerLabel";
import NewBuyerLabelAndHistoryDrawer from "@components/StatuLabel/NewBuyerLabelAndHistoryDrawer";
import Helper from "../../../utils/helper";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import OtherConnect from "./components/OtherConnect";
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import "./followEditInformation.less";

export default class FollowEditInformation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            id: parseInt(qs.parse(this.props.location.search).id),
            loading: false,
            // 客户信息补充
            customerExtra: {
                id: null,
                buyerId: null,
                contact: null,
                storeNum: null,
                url: null,
                // isTargetCustomer: 1,
                otherCategory: null,
                isNoPlatformCategory: null,
                isForeignUser: null,
                remark: null,
                position: null,
                companyType: null,
                salesSkuCount: null,
                sellChannel: null,
                annualSale: null,
                firstFollowerUser: null,
                followerUserId: null,
                manageCategory: null,
                followRemark: null,
                isCorporateEnterprise: null,
                isOneBox: null,
                socialMediaList:null
            },
            showyOptions : [
                {
                    name:'contact',
                    cnTitle:'联系人',
                    cnTitleId:'LianXiRen',
                    cnPlaceholder:'请输入客户联系人',
                    cnPlaceholderId:'QingShuRuKeHuLianXiRen',
                    className: 'row50',
                    maxLength:100
                },
                {
                    name:'position',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择联系人职务',
                    cnPlaceholderId:'QingXuanZeLianXiRenZhiWu',
                    type:"Enum",
                    enumClass:"buy_buyer_position",
                    valueKey:"id",
                    className: 'row50Right',
                },
                {
                    name:'companyType',
                    cnTitle:'公司类型',
                    cnTitleId:'GongSiLeiXing',
                    cnPlaceholder:'请选择公司类型',
                    required:true,
                    cnPlaceholderId:'QingXuanZeGongSiLeiXing',
                    type:"Enum",
                    enumClass:"buy_buyer_company_type",
                    valueKey:"id",
                    className: 'row100',
                    change:(value,option)=>this.changePosition(value,option)
                },
                {
                    name: 'isCorporateEnterprise',//'mainCategoryIds',
                    cnTitle:'是否法人企业',
                    cnTitleId:'ShiFouFaRenQiYe',
                    required:true,
                    type:"RadioButton",
                    radioClass:"is_corporate_enterprise",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name: 'isOneBox',//'mainCategoryIds',
                    cnTitle:'是否 1 箱起订',
                    cnTitleId:'ShiFouXiangQiDing',
                    required:true,
                    type:"RadioButton",
                    radioClass:"is_one_box",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name: 'categoryIdList',//'mainCategoryIds',
                    cnTitle:'经营类目',
                    cnTitleId:'JingYingLeiMu',
                    cnPlaceholder:'请选择经营类目',
                    cnPlaceholderId:'QingXuanZeJingYingLeiMu',
                    type:"Category",
                    className: 'row100',
                },
                {
                    name:'sellChannel',
                    cnTitle:'销售渠道',
                    cnTitleId:'XiaoShouQuDao',
                    cnPlaceholder:'请选择渠道',
                    cnPlaceholderId:'QingXuanZeQuDao',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_channels",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'annualSale',
                    cnTitle:'年销售额',
                    cnTitleId:'NianXiaoShouE',
                    cnPlaceholder:'请选择年度销售额',
                    cnPlaceholderId:'QingXuanZeNianDuXiaoShouE',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_amount",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'salesSkuCount',
                    cnTitle:'在售SKU数',
                    cnTitleId:'ZaiShouSKUShu',
                    cnPlaceholder:'请选择在售SKU数',
                    cnPlaceholderId:'QingXuanZeZaiShouSKUShu',
                    type:"Enum",
                    enumClass:"buy_buyer_sales_sku",
                    valueKey:"id",
                    className: 'row100',
                },
                {
                    name:'storeNum',
                    cnTitle:'线下门店数量',
                    cnTitleId:'XianXiaMenDianShuLiang',
                    cnPlaceholder:'请填写门店数量',
                    cnPlaceholderId:'QingTianXieMenDianShuLiang',
                    type:"Number",
                    numConfig:{
                        precision:0,
                        min: 1,
                        max: 10000
                    },
                    className: 'row100',
                },
                {
                    name:'url',
                    cnTitle:'公司网址',
                    cnTitleId:'GongSiWangZhi',
                    cnPlaceholder:'请输入公司网址',
                    cnPlaceholderId:'QingShuRuGongSiWangZhi',
                    className: 'row100',
                },
            ]
        }
    }
    // 请选择联系人职务显示法人企业
    changePosition(value){
        const {showyOptions,otherPositionDict={}} = this.state;
        let nList = [... showyOptions]
        let flag = true;//默认 隐藏
        let current = {}
        if(isEmptyObject(otherPositionDict)){
            const list = __getDictList("buy_buyer_company_type")||[];//公司性质
            current = list.find(item=>item.code=="19");//如果是其他 即显示
            this.setState({
                otherPositionDict:current,
            })
        }else {
            current = otherPositionDict;
        }
        if(value==current.id){
            flag = false;
        }
        const Inx = nList.findIndex(item=>item.name=="isCorporateEnterprise");
        nList[Inx]["hidden"] = flag;
        nList[Inx]["required"] = !flag;
        this.setState({
            showyOptions: nList
        })
    }
    /**
     * 客户信息
     */
    getCustomer() {
           this.loading(true);
           FollowAction.postAction("/service/mg/follower/user/buyerId",{
              id: this.state.id,
          }).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    /**
     * 加载中
     */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    submitLoading(flag) {
        this.setState({
            submitLoading: flag,
        });
    }
    handleRes(res){
        const {success,valid,model={}} = res;
        if(success&&valid){
            let myCustomer = {...model}
            for (const key in myCustomer) {
                if (key == "mainCategoryIds") { //主营类目处理
                    const record = myCustomer[key]
                    const list = record.split(",") || [];
                    const nameList = myCustomer.mainCategoryName ? myCustomer.mainCategoryName.split("|") : [];
                    let categoryInit = []
                    list.forEach((item, i) => {
                        categoryInit.push({
                            value: Number(item),
                            label: nameList.length > i ? nameList[i] : ""
                        })
                    })
                    myCustomer["categoryIdList"] = categoryInit
                }
                if (
                    Object.hasOwnProperty.call(myCustomer, key) &&
                    key.includes("DictId") &&
                    myCustomer[key] !== null
                ) {
                    myCustomer[key.replace("DictId", "")] =
                        myCustomer[key].indexOf(",") !== -1
                            ? myCustomer[key]: myCustomer[key]+"";//parseInt(myCustomer[key]);
                }
            }
            this.setState({
                cusModel:myCustomer
            },()=>this.loading(false));
            /*if(myCustomer.companyType){//根据 公司性质 显示法人问题
                this.changePosition(myCustomer.companyType)
            }*/
            this.changePosition(myCustomer.companyType)
        }else{
            if(res.message){
                message.warning(res.message);
            }
            this.loading(false);
        }
    }
    /*
    * 行
    * */
    renderRow(title,value="-"){
        return(<div className={"flex-item-between rowItem lineH_21"}>
            <span className={"fw_500"}>{title}</span><div className={"black66"}>{value}</div>
        </div> )
    }
    /*
    * 提交
    * */
    async postData() {
        const {cusModel, customerExtra,otherPositionDict={}} = this.state;
        const res = await this.onRefFormFormat.handleOK();
        const resEamil = await this.onRefFormFormat2.handleOK();
        if (res && res.success) {
            let values = {...cusModel,...res.data};
            const email = resEamil.success?resEamil.data.emaill:"";
            if(email){
                return false
            }else {
                values["email"] = email;
            }
            const socialMediaList = this.onRefFormOtherConnect.handleOK();
            if (socialMediaList && socialMediaList.success) {
                values["socialMediaList"] = socialMediaList.list;
            }else {
                return false
            }
            let data = Helper.overwrite(customerExtra, values);//旧逻辑，
            if (values.categoryIdList) {
                let mainCategoryIds = "";
                values.categoryIdList.forEach((item, i) => {
                    mainCategoryIds += (i > 0 ? "," : "") + item.value;
                })
                data["mainCategoryIds"] = mainCategoryIds;// 保存 类目
                // delete customer.categoryIdList;
            }
            if(data.companyType){
                let current = {}
                if(isEmptyObject(otherPositionDict)){//拿过不再拿
                    const list = __getDictList("buy_buyer_company_type")||[];//公司性质
                    current = list.find(item=>item.code=="19");// 其他的字典ID
                }else {
                    current = otherPositionDict;
                }
                if(current.id!=data.companyType){// 职位 非其他的，默认为法人企业
                    const enList = __getDictList("is_corporate_enterprise")||[];//是否法人企业
                    const cuEn = enList.find(en=>en.code==1); //从code中拿对应ID
                    data['isCorporateEnterprise'] = cuEn.id;
                }
            }
            // if (cusModel.firstFollowerUserId) { 原来是分开两条线，后面需求调整后处理的内容一样，现不分开
            this.submitLoading(true);
            FollowAction.putAction("/service/mg/follower/user", data).then(res => this.handleSaveRes(res.data)).catch(err => this.handleSaveRes(err));
        }
    }
    /*
    * 取消跟进
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8302
    * */
    cancelFollower(){
        this.submitLoading(true);
        FollowAction.postAction("/service/mg/follower/cancel-follower", {
            buyerId: this.state.id,
        }).then(res => this.handleSaveRes(res.data)).catch(err => this.handleSaveRes(err));
    }
    handleSaveRes(res){
        const {success,valid,} = res;
        if (valid && success) {
            message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}));
            setTimeout(()=>this.props.history.push("/customer/list"),400);
        } else if(res.message){
            message.error(res.message);
        }else {
            message.info(Lang({id: 'CaoZuoShiBai',default:'操作失败'}));
        }
        this.submitLoading(false);
    }
    /*
    * 创建分销
    * */
    creatUser =()=>{
        const { cusModel, } = this.state;
        let postData = {
            buyerId:cusModel.buyerId,
        }
        this.submitLoading(true);
        FollowAction.AddFxAccount(postData).then(res=>this.handleResCreatUser(res.data)).catch(err=>this.handleResCreatUser(err));
    }
    handleResCreatUser(res){
        this.submitLoading(false);
        const {success,valid,model} = res;
        if(success&&valid){
            this.setState({
                isModalVisible:true,
                creatAccount:model
            })
        }else if(res.message)message.warning(res.message);
    }
    /**
     * 复制动作
     ***/
    handleCopy(mobile=''){
        const txt =__getServerLanguage("ZhangHao")+'：'+ mobile+'，' + __getServerLanguage("MiMa")+'：'+ mobile;
        let key = 'execCommandAgent';
        let agent = document.getElementById(key);
        if (!agent) {
            const e = document.createElement('input');
            e.id = key;
            e.style.position = 'absolute';
            e.style.top = '-40px';
            e.style.left = 0;
            document.body.appendChild(e);
            agent = document.getElementById(key);
        }
        agent.value = txt;
        agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        message.success(Lang({id:"FuZhiChengGong",default:"复制成功"}))
    }
    closeModal(){
        this.setState({
            isModalVisible:false,
            creatAccount:''
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefForm2= (ref) =>  this.onRefFormFormat2 = ref;
    onRefOtherConnect = (ref) =>  this.onRefFormOtherConnect = ref;
    renderEmail(cusModel,catUpdateEmail,isCountDown,showVCodeTime){
        // const {cusModel} = this.state;
        return (catUpdateEmail?<div className={"ml_6 showEmailVer flex-item-ver-center"}>
            <Input  style={{width:'200px'}}
                    suffix={<>
                        {isCountDown?<>
                            {showVCodeTime>0?<span className={"black33"}>({showVCodeTime}s)</span>:<span className={"font-main2 ml_6 cursor-p"}
                                                                                                                               onClick={()=>this.sendVerCode()}>
                                        {Lang({id:"ChongXinFaSong",default:"重新发送"})}
                                    </span>}
                            </>:<span className={"font-main2 cursor-p fw_500"} onClick={()=>this.sendVerCode()}>{Lang({id:"FaSong",default:"发送"})}</span>}
                    </>}
                    onChange={(e)=>this.setState({
                        verificationCode:e.target.value
                    })}
                   placeholder={Lang({id:"YanZhengMa",default:"验证码"})} />
            <div className={"font-main2 ml_6 cursor-p fw_500"} onClick={()=>this.submitEmail()}>
                {Lang({id:"TiJiao",default:"提交"})}
            </div>
        </div>:<div className={"ml_6 showEmailVer flex-item-ver-center"}>
            <CustomerEmailStatus verifyEmailStatus={cusModel.verifyEmailStatus+""} />
            {cusModel.canOperation?<span className={"font-main2 ml_6 cursor-p"} onClick={()=>this.setUpdateEmail()}>{Lang({id:"XiuGaiHuoYanZhengYouXiang",default:"修改或验证邮箱"})}</span>:null}
            {/*<span className={"font-main2 ml_6 cursor-p"} onClick={()=>this.setUpdateEmail()}>{Lang({id:"XiuGaiHuoYanZhengYouXiang",default:"修改或验证邮箱"})}</span>*/}
        </div>)
    }
    /**
     * 开始定时
     * */
    sendEmailTimeOut(time=120){
        if(time>=0){
            this.setState({
                showVCodeTime: time
            })
            this.sCodeTimer = setTimeout(()=>this.sendEmailTimeOut(time-1), 1000);
        }else clearTimeout(this.vCodeTimer);
    }
    /*
    * 发送邮箱验证码
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8359
    * */
    async sendVerCode(){
        const resEamil = await this.onRefFormFormat2.handleOK();
        const email = resEamil.success?resEamil.data.email:"";
        const { cusModel } = this.state;
        if(!email){
            message.warning(Lang({id:"QingShuRuZhengQueDeYouXiang",default:"请输入正确的邮箱"}));
            return false
        }else {
            const mail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; //  ^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
            const flag =  mail.test(email)
            if(!flag){
                message.warning(Lang({id:"QingShuRuZhengQueDeYouXiang",default:"请输入正确的邮箱"}));
                return false
            }
            const postData = {
                buyAccountId: cusModel.buyerUserId,
                email:email
            }
            this.submitLoading(true);
            FollowAction.postAction("/service/mg/follower/buyer/send-email-verification-code",postData).then(res=>this.handleResVerCode(res.data,false,true)).catch(err=>this.handleResVerCode(err));
        }
    }
    handleResVerCode(res,flagSetCatUpdateEmail=false,sendEmailTimeOut=false){
        this.submitLoading(false);
        const {success,valid,model} = res;
        if(success&&valid){
            if(flagSetCatUpdateEmail){//提交成功，将input 恢复 不可编辑
                this.setState({
                    catUpdateEmail:false,//isCountDown=false,showVCodeTime=0
                    isCountDown:false,
                    showVCodeTime:0
                })
                this.getCustomer();
            }
            if(sendEmailTimeOut){
                message.success(Lang({id:"YouJianYiFaSong",default:"邮件已发送"}));//
                this.setState({
                    isCountDown:true
                })
                this.sendEmailTimeOut();
            }
        }else if (res.message) {
            message.warning(res.message);
            return false
        }
    }
    /*
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8360
    * */
    async submitEmail(){
        const {verificationCode, cusModel} = this.state;
        const resEamil = await this.onRefFormFormat2.handleOK();
        const email = resEamil.success?resEamil.data.email:"";
        if(!email){
            message.warning(Lang({id:"QingShuRuZhengQueDeYouXiang",default:"请输入正确的邮箱"}));
            return false
        }else {
            const mail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; //  A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
            const flag =  mail.test(email)
            if(!flag){
                message.warning(Lang({id:"QingShuRuZhengQueDeYouXiang",default:"请输入正确的邮箱"}));
                return false
            }
        // if(!verificationCode){
        //     message.warning(Lang({id:"QingShuRuYanZhengMa",default:"请输入验证码"}));
        //     return false
        // }else { }
                const postData = {
                    buyAccountId: cusModel.buyerUserId,
                    email:email,
                    verificationCode:verificationCode
                }
                this.submitLoading(true);
                FollowAction.postAction("/service/mg/follower/buyer/submit-email-verification",
                    postData).then(res=>this.handleResVerCode(res.data,true)).catch(err=>this.handleResVerCode(err));
        }
    }
    setUpdateEmail(){
        this.setState({
            catUpdateEmail:true
        })
    }
    componentWillMount() {
        this.getCustomer()
    }
    componentDidMount() {
    }
    render() {
        const {loading = true, cusModel={},showyOptions=[],submitLoading=false,isModalVisible=false,creatAccount,catUpdateEmail=false,isCountDown=false,showVCodeTime=0,} = this.state;
        return (<Spin spinning={loading||submitLoading}>
            <CommonBreadcrumb list={[{name:<Lang id="KeHuXinXi">客户信息</Lang>,link:"/customer/list"},{name:<Lang id="KeHuRenZheng">客户认证</Lang>}]}></CommonBreadcrumb>
            <div className="followEditInformation flex-item black89 fw_400 font_14">
                <div className={"leftInfo"}>
                    <div className={"font_24 fw_500 lineH_36"}>{cusModel.code}</div>
                    <div className={"font_16 lineH_24"}>{cusModel.name}</div>
                    <div className={"btnLine mb_16 mt_16 flex-item"}>
                        <NewBuyerLabelAndHistoryDrawer statusCode={cusModel.newBuyerLabelDictCode}
                                       status={cusModel.newBuyerLabelName}
                                       buyerId={cusModel.buyerId}
                                       labelType={"1010"}//1010:新客标签 1020:成交客户标签
                             />
                        <TargetLabel className={"ml_8"} isTarget={cusModel.isTargetCustomer} />
                    </div>
                    {this.renderRow(<Lang id="ShuiWuHao">纳税人识别号</Lang>,cusModel.taxRegistrationNo)}
                    {this.renderRow(<Lang id="YingYeZhiZhao">营业执照</Lang>,cusModel.businessLicenseNo)}
                    {this.renderRow(<Lang id="LianXiDianHua">联系电话</Lang>,cusModel.mobile)}
                    {this.renderRow(<Lang id="DianZiYouXiang">电子邮箱</Lang>,cusModel.email)}
                    {this.renderRow(<Lang id="JiaoHuoDiQu">交货地区</Lang>,cusModel.lclDeliveryAddress)}
                    {this.renderRow(<Lang id="XiaoShouQuDao">销售渠道</Lang>,cusModel.buySellChannel)}
                    {this.renderRow(<Lang id="GongSiDiZhi">公司地址</Lang>,cusModel.address)}
                    {this.renderRow(<Lang id="YiXiangCaiGouShangPin">意向采购商品</Lang>,<div className={"mainCate"}>{cusModel.mainCategoryName}</div>)}
                    {this.renderRow(<Lang id="TuiGuangFangShi">推广方式</Lang>,cusModel.channelMode)}
                    {this.renderRow(<Lang id="QuDao">渠道</Lang>,isEmpty(cusModel.channelSource)?null:cusModel.channelSource)}
                    {this.renderRow(<Lang id="ShouCiZhuCePingTai">首次注册平台</Lang>,cusModel.registerPlatform)}
                    {this.renderRow(<Lang id="ShouCiGenJin">首次跟进</Lang>,<div className={"text-right"}>
                        <div>{cusModel.firstFollowerUser}</div>
                        <div className={"black45"}>{cusModel.createTime?dayjs(cusModel.createTime).format("YYYY-MM-DD HH:mm:ss"):"-"}</div>
                    </div>)}
                </div>
                <div className={"rightForm ml_16"}>
                    <div className={"font_18 fw_500 lineH_27"}><Lang id="KeHuXinXiWanShan">客户信息完善</Lang></div>
                    <Alert className={"blueMsg mt_16 mb_16"}
                           message={<Lang id="KeHuFuHeYiXiaTiaoJianHuiZ">客户符合以下条件会自动变为目标客户：</Lang>}
                           description={<div className={"blueMsgUl"} dangerouslySetInnerHTML={{__html:Lang({id:"ShiFouShiFaRenQiYeHtml",default:"<ul><li>是否是法人企业；</li><li>经营类目在我们范围之内</li><li>是否1箱起订</li></ul>"})}}
                            />}
                           type="info" showIcon />
                    {!loading&&<div>
                        <FormFormat onRef={this.onRefForm2}
                                    options={[{
                                        name:'email',
                                        cnTitle:'电子邮箱/用户账号',
                                        cnTitleId:'DianZiYouXiangYongHuZhang',
                                        className: 'row50 disableView',
                                        disabled:!catUpdateEmail,
                                        maxLength:100,
                                        // type:"Email",
                                    }, {
                                        type:'OnlyRender', // 修改或验证邮箱
                                        onlyRender:this.renderEmail(cusModel,catUpdateEmail,isCountDown,showVCodeTime),
                                        className: 'row50',
                                    }]}
                                    size={"middle"}
                                    className={"flex-item"}
                                    formLayout = "vertical"
                                    initialValues={cusModel} />
                        <FormFormat onRef={this.onRefForm}
                                            options={showyOptions}
                                            size={"middle"}
                                           // formLayout="inline"
                                           className={"flex-item"}
                                            formLayout = "vertical"
                                            initialValues={cusModel} />
                    </div>}
                    {!loading&&<OtherConnect onRef={this.onRefOtherConnect} socialMediaList={cusModel.socialMediaList} />}
                    <div className={"mb_40"}>
                        <Button type="primary" loading={submitLoading} size="large" onClick={()=>this.postData()}>
                            <Lang id="BaoCun">保存</Lang>
                        </Button>
                        <Popconfirm
                            title={Lang({id:"QueRenFangQiGaiKeHu",default:"确认放弃该客户？"})}
                            onConfirm={()=>this.cancelFollower()}
                            okText={Lang({id:'QueDing', default:'确定'})}
                            cancelText={Lang({id:'QuXiao', default:'取消'})}
                        >
                            <Button type="primary" className={"ml_8 pinkBtn"} loading={submitLoading} size="large">
                                <Lang id="WoFangQiGaiKeHu">我放弃该客户</Lang>
                            </Button>
                        </Popconfirm>

                        <Button className={"ml_8"} loading={submitLoading} size="large" onClick={()=>this.creatUser()}>
                            <Lang id="ShengChengFenXiaoShang">生成分销商</Lang>
                        </Button>
                        <Button size="large"className={"ml_8"} loading={submitLoading} >
                            <Link to="/customer/list">
                                <Lang id="FanHui">返回</Lang>
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
            {/*  离开释放锁  */}
            <Prompt
                message={(location, action) => {
                    if (!location.pathname.startsWith("/dashboard")) {
                        unlock({
                            buyerId: this.state.id,
                        });
                    }
                }}
            />
            {isModalVisible&&<Modal footer={null} open={isModalVisible}onCancel={()=>this.closeModal()} width={300} className={"successWrap"}>
                <Result
                    status="success"
                    title={Lang({id:"ShengChengChengGong",default:"生成成功"})}
                    subTitle={<div><p>
                        {Lang({id:"ZhangHao",default:"账号"})}<span>{creatAccount}</span>
                    </p><p>
                        {Lang({id:"MiMa",default:"密码"})}<span>{creatAccount}</span>
                    </p></div>}
                    extra={[
                        <Button key="copy" className={"btn"} onClick={()=>this.handleCopy(creatAccount)}>
                            {Lang({id:"FuZhiZhangHaoMiMa",default:"复制账号和密码"})}
                        </Button>
                    ]}
                />
            </Modal>}
        </Spin>);
    }
}
